<template>
  <svg class="icon-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-html="iconContent" />
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  name: {
    type: String,
    required: true
  }
})

const icons = {
  target: `<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="12" r="3" fill="currentColor"/><path d="M12 2v4M12 18v4M2 12h4M18 12h4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>`,
  swap: `<path d="M4 9h12M4 9l3-3M4 9l3 3M20 15H8M20 15l-3-3M20 15l-3 3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>`,
  map: `<path d="M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3V6z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M9 3v15M15 6v15" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>`,
  medal: `<circle cx="12" cy="9" r="5" stroke="currentColor" stroke-width="2"/><path d="M8 13l-2 8 6-3 6 3-2-8" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>`,
  gun: `<path d="M4 18h10l2-4h3v-3h-5l-2 4H7l-2 4H4v-1z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M20 11h2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>`,
  mic: `<rect x="9" y="3" width="6" height="10" rx="3" stroke="currentColor" stroke-width="2"/><path d="M6 11a6 6 0 0 0 12 0M12 18v4M8 22h8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>`,
  sword: `<path d="M14.5 17.5L3 6l3-3 11.5 11.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M18 21l-3.5-3.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="16" cy="19" r="3" stroke="currentColor" stroke-width="2"/>`,
  shield: `<path d="M12 22s8-4 8-10V4l-8-2-8 2v8c0 6 8 10 8 10z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>`,
  'red-circle': `<circle cx="12" cy="12" r="8" fill="#ef4444"/>`,
  'blue-circle': `<circle cx="12" cy="12" r="8" fill="#3b82f6"/>`,
  assault: `<path d="M3 18h12l2-3h4v-2h-4l-2 3H6l-2 3H3v-1z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M21 13h2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>`,
  sniper: `<rect x="2" y="10" width="20" height="4" rx="1" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="12" r="2" fill="currentColor"/><path d="M20 12h2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>`,
  smg: `<path d="M4 18h8l1-2h5v-2h-5l-1 2H7l-2 2H4v0z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>`,
  shotgun: `<path d="M4 18h10l2-4h3v-3h-5l-2 4H7l-2 4H4v-1z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M19 11h2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>`
}

const iconContent = computed(() => icons[props.name] || '')
</script>

<style scoped>
.icon-svg {
  width: 1em;
  height: 1em;
  display: inline-block;
  vertical-align: middle;
}
</style>
